import type React from 'react'
import { useLayoutEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import type { Crumb } from './BreadcrumbContext'
import { useSetBreadcrumbs } from './BreadcrumbContext'

export const usePageBreadcrumbs = (crumbs: Crumb[] | null, options?: { loading?: boolean }): void => {
  const setCrumbs = useSetBreadcrumbs()
  const { pathname } = useLocation()
  const loading = options?.loading ?? false
  const serialized = crumbs ? JSON.stringify(crumbs) : null

  useLayoutEffect(() => {
    if (crumbs === null) return
    setCrumbs(crumbs, pathname, loading)
  }, [serialized, pathname, loading, setCrumbs])
}

type TabLike = {
  type: string | number
  url: string
  label: React.ReactNode
  hidden?: boolean
}

export const useTabCrumb = (tabs: TabLike[], active: string | number | undefined): Crumb | null => {
  return useMemo(() => {
    if (active === undefined || active === null) return null
    const tab = tabs.find(t => t.type === active)
    if (!tab || typeof tab.label !== 'string') return null
    return { label: tab.label, to: tab.url }
  }, [tabs, active])
}
